
import { initReactI18next } from "react-i18next";
//Dwa razy import zeby dzialal build i testy, inaczej jest blad
let i18 = require('i18next');
import i18n from "i18next";
import mainMenu from './MainMenu';
import carDetails from './CarDetails';
import forms from './Forms';
import errors from './Errors';
import tables from './Tables';
import dictionary from './Dictionary';
import popup from './Popup';
import reports from './Reports';

if(!i18?.use) {
    i18 = i18n;
}

i18
.use(initReactI18next)
.init({
    interpolation: { escapeValue: false },
    lng: localStorage.getItem('activeLanguage') || 'pl',
    fallbackLng: 'pl',
    resources: {
        pl: {
            mainMenu: mainMenu.PL,
            carDetails: carDetails.PL,
            forms: forms.PL,
            errors: errors.PL,
            tables: tables.PL,
            dictionary: dictionary.PL,
            popup: popup.PL,
            reports: reports.PL
        },
        en: {
            mainMenu: mainMenu.EN,
            carDetails: carDetails.EN,
            forms: forms.EN,
            errors: errors.EN,
            tables: tables.EN,
            dictionary: dictionary.EN,
            popup: popup.EN,
            reports: reports.EN
        },
        es: {
            mainMenu: mainMenu.ES
        },
        pt: {
            mainMenu: mainMenu.PT
        }
    }
});

export default i18;



// WEBPACK FOOTER //
// ./src/Translations/_i18n.ts